<template>
  <header class="d-flex flex-row flex-wrap justify-content-between">
    <section class="d-flex flex-row justify-content-between">
      <img class="img-fluid" alt="" title="" src="../../assets/img/logo-1.png">
      <div>
        <font-awesome-icon :icon="['fas', 'home']"></font-awesome-icon>
        <span>AVAP</span>
      </div>
      <div>
        <font-awesome-icon :icon="['fas', 'question-circle']"></font-awesome-icon>
        <span>4</span>
      </div>
      <div>
        <font-awesome-icon :icon="['fas', 'comment-alt']"></font-awesome-icon>
        <span>8</span>
      </div>
      <div>
        <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
        <span>12</span>
      </div>
      <div>
        <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        <span>Créer</span>
        <ul>
          <li>
            <font-awesome-icon :icon="['fas', 'newspaper']"></font-awesome-icon>
            <span>Actualités</span>
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'user-cog']"></font-awesome-icon>
            <span>Administrateurs</span>
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'people-carry']"></font-awesome-icon>
            <span>Agents</span>
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'clipboard-list']"></font-awesome-icon>
            <span>Catégories des produits</span>
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'question-circle']"></font-awesome-icon>
            <span>Faq</span>
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'percentage']"></font-awesome-icon>
            <span>Promotions</span>
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'user-secret']"></font-awesome-icon>
            <span>Super utilisateurs</span>
          </li>
        </ul>
      </div>
    </section>
    <section>
      <span>Bonjour, Ridi</span>
      <font-awesome-icon :icon="['fas', 'user-cog']"></font-awesome-icon>
    </section>
  </header>
</template>

<script>
export default {
name: "Header"
}
</script>

<style lang="scss" scoped>
header{
  background-color: var(--color-maya-blue, rgba(100, 181, 246, 1));
  color: var(--color-white, rgba(255, 255, 255, 1));
  font-size: large;
  & > section:first-child{
    & > img{
      width: 7%;
    }
    & > div{
      padding: .25rem .5rem;
      height: 100%;
      & > span{
        font-weight: lighter;
      }
    }
    & > div:last-child{
      & > ul{
        z-index: 3;
        display: none;
        margin-top: 4px;
        margin-left: -8px;
        position: absolute;
        list-style: none;
        padding-left: 0;
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        width: 220px;
        & > li{
          font-size: medium;
          padding: .25rem .5rem;
          border-bottom: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
          & > svg{
            width: 13%;
          }
        }
        & > li:hover{
          background-color: var(--color-white, rgba(255, 255, 255, 1));
          color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          border: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
        }
      }
    }
    & > div:last-child:hover{
      & > ul{
        display: block;
      }
    }
    & > div:hover{
      background-color: var(--color-white, rgba(255, 255, 255, 1));
      color: var(--color-maya-blue, rgba(100, 181, 246, 1));
      cursor: pointer;
    }
  }
  & > section:last-child{
    font-weight: lighter;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue